module.exports = __webpack_public_path__ + "img/arrow-down.5381bbf4.svg";